import React, { Component } from "react"
import PropTypes from "prop-types"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"
import { connectionShape } from "app/lib/shared_prop_types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import appletOrConnectionPath from "app/scripts/applet_or_connection_path"

export class StoryAppletCard extends Component {
  handleOnClick = () => {
    logIFTTTNextAction("click", {
      location_type: "story",
      connection_status: this.props.applet.status,
      object_id: this.props.applet.id,
      object_type: "connection",
      position: this.props.position,
      field_position: this.props.fieldPosition,
    })
  }

  //TO DO: Create a story field model that will handle this.
  filterPermissions = () => {
    return this.props.applet.permissions.filter((permission, idx) => {
      return permission.service_slug !== this.props.applet.service_slug
    })
  }

  render() {
    return (
      <li
        className="my-web-applet-card web-applet-card"
        ref={el => {
          this.scrollObserverEl = el
        }}
      >
        <a
          className="applet-card-body"
          style={{ backgroundColor: this.props.applet.brand_color }}
          href="#"
          onClick={this.handleOnClick}
        >
          <SmallAppletCard
            applet={this.props.applet}
            appletPath={appletOrConnectionPath(this.props.applet)}
            onAppletClick={this.handleOnClick}
            overrideToConsumerSite={this.props.linkAppletCardsToConsumerSite}
          />
        </a>
      </li>
    )
  }
}

StoryAppletCard.propTypes = {
  applet: connectionShape.isRequired,
  term: PropTypes.string,
  position: PropTypes.number.isRequired,
  fieldPosition: PropTypes.number,
  linkAppletCardsToConsumerSite: PropTypes.bool,
}

StoryAppletCard.defaultProps = {
  linkAppletCardsToConsumerSite: false,
}

export default StoryAppletCard
